








import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { LoadingStatusType } from "./enums/enums";
import Layout from "./views/Layout.vue";
import IsLoading from "@/components/element/IsLoading.vue";
import {
  BroadcastTabChannelMasterTabClose,
  CheckBroadcastIsSupport,
  SetTabChannel,
} from "./broadcastChannel/tabChannel";
import { SocketConnect, SocketDisconnect } from "./helper/notificationHelper";
import { CheckIndexedDBIsSupport } from "./IndexedDB/tabIndexedDB";
import {
  ClearMasterTabFromCookies,
  ClearTabFromSessionStorage,
  GetTabIdFromSessionStorage,
  IsMasterTab,
  RemoveTabDB,
  IsMasterTabAvailable,
} from "./helper/tabHelper";

const StoreLogIn = namespace("LogIn");

@Component({
  components: {
    Layout,
    IsLoading,
  },
})
export default class App extends Vue {
  private useLayoutPage = false;
  private render = true;

  @StoreLogIn.Getter
  private getLoginLoadingStatus!: LoadingStatusType;

  created() {
    SetTabChannel();
  }

  mounted() {
    window.addEventListener("focus", () => {
      if (this.getLoginLoadingStatus == LoadingStatusType.Success && !IsMasterTabAvailable()) {
        SocketConnect();
      }
    });
    window.addEventListener("beforeunload", async () => {
      SocketDisconnect();
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        const tabId = GetTabIdFromSessionStorage();
        const isMasterTab = IsMasterTab();
        if (isMasterTab) {
          ClearMasterTabFromCookies();
          BroadcastTabChannelMasterTabClose();
        }
        if (tabId) {
          ClearTabFromSessionStorage();
          await RemoveTabDB(tabId);
        }
      }
    });
  }

  destroyed() {
    localStorage.removeItem("lang");
  }
  get isLoginSuccess(): boolean {
    return this.getLoginLoadingStatus === LoadingStatusType.Success;
  }
  @Watch("$localStorage.lang", { immediate: true })
  localStorageLangChanged(newVal: any, oldVal: any) {
    if (localStorage.lang != null) {
      this.$i18n.locale = localStorage.lang;
    }
  }

  @Watch("$route", { immediate: true })
  routeChanged(newVal: any) {
    this.setWebTitle(this.$t(newVal.meta.title));
    this.render = false;
    if (newVal.name) {
      this.setUseLayoutPage(newVal.name);
      this.$nextTick(() => {
        this.render = true;
      });
    }
  }

  @Watch("$i18n.locale")
  localeChanged(newVal: any) {
    localStorage.setItem("lang", newVal);
    this.setWebTitle(this.$t(this.$route.meta.title));
  }

  public setUseLayoutPage(routerName: string) {
    switch (routerName) {
      case "login":
      case "selectList":
      case "logout":
      case "statement":
      case "pageNotFound":
      case "sessionExpire":
      case "canNotAccessMerchant":
      case "CanNotAccess":
      case "update":
        this.useLayoutPage = false;
        break;

      default:
        this.useLayoutPage = true;
        break;
    }
  }

  public setWebTitle(title: any) {
    if (title) {
      document.title = title;
    }
  }
}
